// this is a generated file, do not edit directly. See Google sheets to update variable config 
export const defaultData = "county_nyt.geojson" 
export const tooltipTables = ["cases","deaths","testing_wk_pos","test_tcap","vaccines_fully_vaccinated","vaccines_one_dose"] 
